import script from "./XDataTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./XDataTable.vue?vue&type=script&lang=ts&setup=true"

import "./XDataTable.vue?vue&type=style&index=0&id=30fb92e0&lang=scss&scoped=true"

import exportComponent from "D:\\x1\\vue3-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30fb92e0"]])

export default __exports__